import PhatDropdown from 'components/formElements/PhatDropdown'

type Props = {
  value?: boolean
  onChange: (value: boolean) => void
}

const SortingDropdown = ({ value = false, onChange }: Props) => (
  <PhatDropdown
    value={`${value}`}
    inlineHeader
    header="Sort Direction:"
    options={[
      { label: 'Ascending', onClick: () => onChange(false), id: 'false' },
      { label: 'Descending', onClick: () => onChange(true), id: 'true' },
    ]}
  />
)

export default SortingDropdown
